module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": _vm.appLinks.apple
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/ios.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.appLinks.andriod
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/patient/android.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cba8ff8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppLinks.vue
// module id = 671
// module chunks = 5